import { EmailStateTag } from "@/components/emails";
import { Email } from "@msuite/ui/link";
import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createMeta } from "@msuite/ui/table";
import { createdAtFormatter } from "@msuite/utils/date";
import type { PartnerTimelineReport } from "@msuite/utils/types";

const columnHelper = createColumnHelper<PartnerTimelineReport>();

export const columns = [
	columnHelper.accessor(createdAtFormatter, {
		header: localized("general_fields.created_at"),
		id: "createdAt",
		cell: (cell) => cell.getValue(),
		meta: createMeta({
			isTabular: true,
		}),
	}),
	columnHelper.accessor("projectName", {
		id: "projectName",
		header: localized("projects.project"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("projectNumber", {
		id: "projectNumber",
		header: localized("projects.fields.number"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("reportNumber", {
		id: "reportNumber",
		header: localized("partners.reports.report_number"),
		cell: (cell) => cell.getValue(),
		meta: createMeta({
			isTabular: true,
		}),
	}),
	columnHelper.accessor("email", {
		header: localized("personnel.fields.email"),
		cell: (cell) => <Email>{cell.getValue()}</Email>,
		meta: createMeta({
			isTabular: true,
		}),
	}),
	columnHelper.display({
		id: "state",
		header: localized("general.state"),
		cell: (cell) => (
			<div className="-py-1">
				<EmailStateTag emailId={cell.row.original.emailId} />
			</div>
		),
		meta: createMeta({
			isTabular: true,
		}),
	}),
];
